import * as React from 'react';
import { withAnalyticOnEvent } from 'react-shisell';
import History from 'history';
import { Link, LinkProps } from 'react-router-dom';

type LinkWithAnalyticsProps = LinkProps & { analyticsExtras?: { [key: string]: any } };

const isRelativelLink = (to: History.LocationDescriptor): boolean => to.toString().indexOf('://') === -1;

const LinkWrapper: React.SFC<LinkWithAnalyticsProps> = ({ to, ...props }) =>
  typeof to !== 'function' && isRelativelLink(to) ? <Link to={to} {...props} /> : <a href={to.toString()} {...props} />;

const LinkWithAnalytics = withAnalyticOnEvent<LinkProps>({
  eventName: 'onClick',
  analyticName: 'Click',
})(LinkWrapper);

export { LinkWithAnalytics, LinkWithAnalyticsProps };



// WEBPACK FOOTER //
// ./packages/platform-common-ui/components/LinkWithAnalytics.tsx